import { ClusterType } from "./product-clustertype";

export class ProductClusterManagement {
  private ClusterId: string;
  private PurchaseEnabled: boolean;
  private SubsidyEnabled: boolean;
  private Subsidy: number;
  private DiscountEnabled: boolean;
  private DiscountPercentValue: number;
  private FormPayment: string;
  private clusterType: ClusterType;

  getPercentualSubsidy(): number {
    return this.Subsidy || 0;
  }

  getDiscountPercentValue(): number {
    return this.DiscountPercentValue || 0;
  }

  isPurchaseEnabled(): boolean {
    return this.PurchaseEnabled;
  }

  isSubsidyEnabled(): boolean {
    return this.SubsidyEnabled;
  }

  isDiscountEnabled(): boolean {
    return this.DiscountEnabled;
  }

  getClusterId(): string {
    return this.ClusterId;
  }

  setSubsidy(percentuale: number, enabled: boolean): void {
    this.Subsidy = enabled ? percentuale : 0;
    this.SubsidyEnabled = enabled;
  }

  setDiscount(percentuale: number, enabled: boolean): void {
    this.DiscountPercentValue = enabled ? percentuale : 0;
    this.DiscountEnabled = enabled;
  }

  setPurchase(enabled: boolean): void {
    this.PurchaseEnabled = enabled;
  }

  setClusterType(clusterType: ClusterType) {
    this.clusterType = clusterType;
    this.ClusterId = clusterType.Key;
  }

  getClusterName(): string {
    if (!this.clusterType) return "";
    return this.clusterType.Value;
  }

  getClusterType(): ClusterType {
    return this.clusterType;
  }
    
  setFormPayment(value: string): void {
    this.FormPayment = value;
  }

  getFormPayment(): string {
    return this.FormPayment;
  }
}
